import React from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "../LoadingSpinner";
import { formatCost, formatNumber } from "../../utils/formatters";

/**
 * Usage history table showing past months' usage.
 */
const UsageHistoryTable = ({ invoiceHistory, loading }) => {
  return (
    <div className="settings-card">
      <h3 className="settings-card-title">Usage History</h3>
      {loading ? (
        <LoadingSpinner size="small" text="Loading usage history..." />
      ) : invoiceHistory.length > 0 ? (
        <table className="settings-table">
          <thead>
            <tr>
              <th>Period</th>
              <th>Messages</th>
              <th>Tokens</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {invoiceHistory.map((inv) => (
              <tr key={inv.month}>
                <td>{inv.month}</td>
                <td>{formatNumber(inv.messages)}</td>
                <td>{formatNumber(inv.tokens)}</td>
                <td>{formatCost(inv.cost)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="settings-empty">No usage history available.</p>
      )}
    </div>
  );
};

UsageHistoryTable.propTypes = {
  invoiceHistory: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      messages: PropTypes.number,
      tokens: PropTypes.number,
      cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  loading: PropTypes.bool,
};

UsageHistoryTable.defaultProps = {
  invoiceHistory: [],
};

export default UsageHistoryTable;
